import { render, staticRenderFns } from "./clienteChartSideBar.vue?vue&type=template&id=534d8756"
import script from "./clienteChartSideBar.vue?vue&type=script&lang=js"
export * from "./clienteChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./clienteChartSideBar.vue?vue&type=style&index=0&id=534d8756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports